<template>
  <div>
    <!-- {{ scope.row.orderId }} -->
    <el-table
      :data="contactHistory"
      style="width: 100%"
      :render-header="renderHeader"
      height="calc(100vh - 353px)"
      @sort-change="handleSort"
      :row-class-name="tableRowClassName"
    >
      <el-table-column
        prop="activityModuleId"
        label="任务ID"
        align="left"
        width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.activityModuleId }}
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户ID" align="center" width="150">
        <template slot-scope="scope">
          {{ scope.row.userId }}
        </template>
      </el-table-column>
      <el-table-column
        prop="invitedUserId"
        label="邀请人ID"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.invitedUserId }}
        </template>
      </el-table-column>
      <el-table-column prop="community" label="归属社区" align="center">
        <template slot-scope="scope">
          {{ scope.row.community }}
        </template>
      </el-table-column>
      <el-table-column
        prop="activityModuleName"
        label="任务名称"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.activityModuleName }}
        </template>
      </el-table-column>
      <el-table-column
        prop="activityLotteryName"
        label="已领取奖励"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.activityLotteryName }}
        </template>
      </el-table-column>
      <el-table-column
        prop="activityLotterySize"
        label="数量"
        align="center"
        width="120"
      >
        <!-- 已领取 -->
        <template slot-scope="scope">
          {{ scope.row.activityLotterySize }}
        </template>
      </el-table-column>
      <el-table-column
        prop="activityRemainLotterySize"
        label="奖池剩余"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.activityRemainLotterySize }}
        </template>
      </el-table-column>

      <el-table-column
        prop="completeTime"
        label="完成时间"
        align="right"
        width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.completeTime | moment }}
        </template>
      </el-table-column>
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div>
    <!-- <update-dialog
      :val="userinfoDetail"
      :updateForm="updateForm"
    ></update-dialog> -->

    <!-- 编辑用户信息dialog -->
    <el-dialog
      title="修改备注"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div class="main">
        <el-card class="box-card">
          <div>备注信息</div>
          <div class="content">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入备注信息"
              maxlength="50"
              show-word-limit
              v-model="textarea2"
            >
            </el-input>
          </div>
          <div class="btn">
            <el-button size="mini" type="primary" @click="add">添 加</el-button>
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
    <el-dialog
      title="订单记录"
      :visible="orderVisible"
      width="80%"
      center
      :show-close="false"
    >
      <div class="main">
        <el-table :data="orderList" class="table-fixed" height="300px">
          <el-table-column
            prop="userId"
            label="用户ID"
            align="center"
            min-width="120"
          />
          <el-table-column
            label="订单ID"
            prop="orderId"
            align="center"
            min-width="160"
          />
          <el-table-column
            label="合伙人ID"
            prop="channelUserId"
            align="center"
            min-width="120"
          />
          <el-table-column label="合约名" prop="symbol" align="center" />
          <el-table-column label="方向" align="center">
            <template slot-scope="scope">
              <span
                class="green"
                v-if="scope.row.orderSide == 1 && scope.row.positionSide == 1"
                >买入开多
              </span>
              <span
                class="red"
                v-if="scope.row.orderSide == 1 && scope.row.positionSide == 2"
                >买入平空</span
              >
              <span
                class="green"
                v-if="scope.row.orderSide == 2 && scope.row.positionSide == 1"
                >卖出平多
              </span>
              <span
                class="red"
                v-if="scope.row.orderSide == 2 && scope.row.positionSide == 2"
                >卖出开空</span
              >
            </template>
          </el-table-column>
          <el-table-column label="平仓盈亏" prop="profit" align="center" />
          <el-table-column label="下单价格" prop="price" align="center" />
          <el-table-column label="成交均价" prop="avgPrice" align="center" />
          <el-table-column
            label="开/平仓数量"
            prop="origQty"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.origQty }}</span
              >&nbsp;<span v-if="scope.row.symbol">{{
                transform(scope.row.symbol)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.orderType == 1">限价</span>
              <span v-if="scope.row.orderType == 2">市价</span>
            </template>
          </el-table-column>
          <el-table-column label="杠杆倍数" prop="leverage" align="center" />
          <el-table-column label="触发类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.sourceType == 5">移动止盈止损</span>
              <span v-else-if="scope.row.sourceType == 2">止盈止损</span>
              <span v-else-if="scope.row.sourceType == 3012">爆仓</span>
              <span v-else>普通订单</span>
            </template>
          </el-table-column>
          <el-table-column label="更新时间" align="center" min-width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.updatedTime | moment }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :size="orderPage.size"
          :total="orderTotal"
          :page="orderPage.page"
          @pageChanged="orderPageChanged"
        >
        </pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="colseOrder">取 消</el-button>
      </span>
    </el-dialog>
    <UserDetailDialog :id="id" :type="type" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'
import order from '@/assets/order.png'
import copyImg from '@/assets/copy.png'
import UserDetailDialog from 'components/userDetailDialog'
import { positionOrderList } from '@/common/publicApi'
import tip from '@/assets/partnerCenter/tip.png'
export default {
  name: 'ContactHistoryList',
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: '',
      order,
      tip,
      copyImg,
      type: '',
      id: '',
      cacheRow: {},
      orderList: [],
      orderVisible: false,
      orderPage: {
        page: 1,
        size: 10,
      },
      orderTotal: 0,
    }
  },
  components: {
    Pagination,
    UserDetailDialog,
    updateDialog,
  },
  methods: {
    ...mapActions('closingCommission', ['addRemark']),
    // ...mapActions('taskData', ['getHistory']),

    ...mapMutations('closingCommission', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
    ]),
    ...mapMutations('contractassets', ['setUserDetailInfoVisible']),
    ...mapMutations('taskData', ['setPagination', 'setOrderBy']),
    // getContactHistory() {
    //   this.getHistory()
    // },
    renderHeader(h, { column, $index }) {
      // 新建一个 span
      let span = document.createElement('span')
      // 设置表头名称
      span.innerText = column.label
      // 临时插入 document
      document.body.appendChild(span)
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20
      // 移除 document 中临时的 span
      document.body.removeChild(span)
      return h('span', column.label)
    },

    copy(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success',
        center: true,
      })
      oInput.remove()
    },
    pageChanged(pagination) {
      this.setPagination(pagination)
      this.$emit('refresh', { ...pagination })
    },
    handleUpdate(row) {
      this.updateForm = row
      // this.setUserinfoDetail(row);
      // this.setUserinfoDetailDialogVisible(true);
      this.centerDialogVisible = true
      this.textarea2 = row.remarks
    },
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remarks: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功')
          ;(this.textarea2 = ''), (this.centerDialogVisible = false)
          this.$emit('refresh')
        }
      })
    },
    goDetail(row) {
      this.$router.push({ path: `/home/closingCommission/detail`, query: row })
    },

    copy(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success',
        center: true,
      })
      oInput.remove()
    },
    showBox(row, type) {
      this.type = type
      this.id = type == 2 ? row.userId : row.channelUserId
      this.setUserDetailInfoVisible(true)
    },
    handleSort({ column, prop, order }) {
      this.setOrderBy(null)
      if (order) {
        const orderSort = order === 'descending' ? 'desc' : 'asc'
        this.setOrderBy(`${prop},${orderSort}`)
      }
      this.$emit('refresh')
    },
    getOrderList() {
      positionOrderList({
        positionId: this.cacheRow.id,
        ...this.orderPage,
      }).then((res) => {
        if (res.code == 0) {
          this.orderList = res.data.list
          this.orderTotal = res.data.totalCount
        }
      })
    },
    colseOrder() {
      this.cacheRow = {}
      this.orderPage = {
        page: 1,
        size: 10,
      }
      this.orderTotal = 0
      this.orderVisible = false
    },
    showOrder(row) {
      this.cacheRow = row
      this.orderVisible = true
      this.getOrderList()
    },
    orderPageChanged(pagination) {
      this.orderPage = pagination
      this.getOrderList()
    },
    transform(str) {
      if (str) {
        return str.split('_')[0].toUpperCase()
      }
      return ''
    },
    tableRowClassName({ row }) {
      if (row.mark == true) {
        return 'redRow'
      }
      return ''
    },
  },
  computed: {
    // ...mapGetters('user', ['contactHistory']),
    ...mapState(['userInfo']),
    ...mapState('taskData', [
      'pagination',
      'contactHistory',
      'totalCount',
      'orderBy',
    ]),
  },
}
</script>

<style lang="less" src="../../../../../styles/table.less" scoped></style>
<style lang="less" scoped>
.green {
  color: skyblue;
}
.red {
  color: #f54a45;
}
</style>
